module.exports = __webpack_public_path__ + "static/us_live-f21c0c46c732618f92d89ee081e81548.png";